<template>
  <div class="w-full h-full overflow-auto">
    <div class="max-w-3xl mx-auto py-5">
      <tabs :options="{ useUrlFragment: true }">
        <tab id="transfer-options" :name="i18n.transfer.title">
          <transfer :options="transfer"></transfer>
        </tab>
        <tab id="contact-information" :name="i18n.personal_data.title">
          <personal-data :personal-data="personalData"></personal-data>
        </tab>
        <tab id="preferences" :name="i18n.preferences.title">
          <preferences :preferences="preferences"></preferences>
        </tab>
        <tab id="change-password" :name="i18n.password.title">
          <password :i18n="i18n.password.form"></password>
        </tab>
        <!--tab id="miscellaneous" :name="i18n.miscellaneous.title">
                    <miscellaneous :options="miscellaneous"></miscellaneous>
                </tab-->
      </tabs>
    </div>
  </div>
</template>

<script>
import Transfer from "../User/Settings/Forms/Transfer";
import PersonalData from "../User/Settings/Forms/PersonalData";
import Password from "../User/Settings/Forms/Password";
import Preferences from "../User/Settings/Forms/Preferences";
import { mapState } from "vuex";

export default {
  components: { Transfer, PersonalData, Password, Preferences },
  computed: {
    i18n() {
      if (this.$store.state.account.i18n !== undefined) {
        return this.$store.state.account.i18n.settings;
      }

      return undefined;
    },
    ...mapState({
      personalData: (state) => ({
        ...state.account.contact,
        email: state.account.user.email,
      }),
      preferences: (state) => state.account.preferences,
      transfer: (state) => state.account.transfer,
      miscellaneous: (state) => state.account.miscellaneous,
    }),
  },
};
</script>
